import React, {useEffect, useState} from "react";
import {useHistory, useParams} from "react-router-dom";
import ConfirmationModal from "../../components/Modal/Confirmation/ConfirmationModal";
import {RouteWithId} from "../../routes/types";
import {useAppSelector} from "../../store/hooks";
import {selectPortfolioReserveYears} from "./PortfolioReserveSlice";
import {useAnalyticsTrackers} from "../../utils/useAnalyticsTrackers";

interface SavePortfolioReserveModalProps {
    setPRClicked: boolean
    displayInsufficientWarning : boolean
}

const SavePortfolioReserveModal = ({setPRClicked, displayInsufficientWarning}: SavePortfolioReserveModalProps) => {
    const history = useHistory();
    const [showModal, setShowModal] = useState(false);
    const {id} = useParams<RouteWithId>();
    const {prTargetInputYears, minimumRiskInputYears} = useAppSelector(selectPortfolioReserveYears);
    const {page} = useAnalyticsTrackers();

    useEffect(() => {
        if (setPRClicked) {
            setShowModal(true);
        }
    }, [setPRClicked]);

    function navigateAway() {
        setShowModal(false);
        history.push(`/Profile/${id}/ClientProfile/PortfolioReserve/ReviewPortfolioReserve`);
    }
    return displayInsufficientWarning ?
    <ConfirmationModal
        confirmButtonDestructive={false}
        isOpen={showModal}
        title={"Portfolio Reserve Set"}
        content={"Your Reserve Target and Fund Lifestyle Spending using Non-Investable Assets election has been set."}
        onClickConfirm={() => {
            navigateAway();
        }}
        confirmText={'OKAY'}/>
        : <ConfirmationModal
            confirmButtonDestructive={false}
            isOpen={showModal}
            title={"Portfolio Reserve Set"}
            content={"Your Reserve Target election has been set."}
            onClickConfirm={() => {
                navigateAway();
                page(`Click_Set_Portfolio_Reserve`, {
                    cd8_prTargetYears: prTargetInputYears,
                    cd7_minimumRiskYears: minimumRiskInputYears
                })
            }}
            confirmText={'OKAY'}/>

}

export default SavePortfolioReserveModal
